import { useCallback, useState } from 'react';

import { load, save } from '../../../lui/coffee/utils/localStorage';

export function usePersistedState(key, defaultValue) {
  const [value, setValue] = useState(() => load(key, defaultValue));

  const setPersistedValue = useCallback(
    next => {
      setValue(prev => {
        const resolved = typeof next === 'function' ? next(prev) : next;
        save(key, resolved);
        return resolved;
      });
    },
    [key]
  );

  return [value, setPersistedValue];
}
